import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Card } from "../ui/card";

type MainContentProps = {
  title?: string;
  children?: ReactNode;
};

export const MainContent = ({ title, children }: MainContentProps) => {
  return (
    <Card className="bg-gray-900 max-h-screen h-full">
      <div className="p-8 h-full max-h-screen overflow-y-auto">
        {title && (
          <div className="mb-8">
            <span className="text-white text-2xl">{title}</span>
          </div>
        )}
        {children || <Outlet />}
      </div>
    </Card>
  );
};
